import { createItem, deleteItem, getItem, listItems, updateItem } from './sharepoint';

const LIST = 'reports';

export async function listReports(opts) {
  // Descending by report date so the newest submissions show up first
  return listItems(LIST, { orderby: 'fields/ReportDate desc', ...opts });
}

export const getReport = (id) => getItem(LIST, id);
export const createReport = (model) => createItem(LIST, model);
export const updateReport = (id, model) => updateItem(LIST, id, model);
export const deleteReport = (id) => deleteItem(LIST, id);
